<template>
  <div>
    <img v-if="hasAvatar" class="user-avatar" :height="height" :width="width" :src="userAvatar"/>

    <placeholder-avatar v-else :initials="initials" :height="height" :width="width"/>
  </div>
</template>

<script>
  import PlaceholderAvatar from './PlaceholderAvatar.vue'
  import imageMixin from 'src/utils/mixins/image'

  export default {
    props: {
      user: {
        required: true,
        type: Object
      },

      height: {
        type: String,
        default: '36px'
      },

      width: {
        type: String,
        default: '36px'
      }
    },

    computed: {
      hasAvatar () {
        return this.user.avatar_url
      },

      userAvatar () {
        return this.hasAvatar ? this.getImageUrl(this.user.avatar_url, 'small') : null
      },

      initials () {
        return (this.user.first_name.charAt(0) + this.user.last_name.charAt(0)).toUpperCase()
      }
    },

    mixins: [
      imageMixin
    ],

    components: {
      PlaceholderAvatar
    }
  }
</script>

<style lang="stylus">
  .user-avatar
    border-radius: 50%
    object-fit: contain
</style>
